import type { CmPanelTabsProps } from './cm-panel-tabs.types';
import './cm-panel-tabs.css';

/**
 * Equal-width tab buttons used inside the Custom Module section drawer — Add to Library / Pull From
 * Library on a field row, and Setup / Options in a field's setup card (Figma "Column Setup" component).
 * @param tabs - The tabs, in display order.
 * @param activeKey - Key of the selected tab.
 * @param onChange - Called with the key of the tab the user picks.
 * @param ariaLabel - Accessible name of the tab list.
 * @param className - Extra class for the tab list.
 * @returns The tab list.
 */
function CmPanelTabs<Key extends string>({ tabs, activeKey, onChange, ariaLabel, className = '' }: CmPanelTabsProps<Key>) {
  return (
    <div className={['cm-panel-tabs', className].filter(Boolean).join(' ')} role="tablist" aria-label={ariaLabel}>
      {tabs.map((tab) => {
        const isActive = tab.key === activeKey;
        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={['cm-panel-tabs__tab', isActive ? 'cm-panel-tabs__tab--active' : ''].filter(Boolean).join(' ')}
            onClick={() => onChange(tab.key)}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}

export default CmPanelTabs;
